export const styles = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '16px',
  },

  itemContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    flexDirection: 'row',
    border: '1px solid #EDEFF7',
    borderRadius: '8px',
    gap: '8px',
    padding: '8px 4px 8px 8px',
  },

  firstPartContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    justifyContent: 'flex-start',
  },

  secondPartContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    paddingRight: '8px',
  },

  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px',
  },

  nameContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    justifyContent: 'flex-start',
  },

  name: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#23252F',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    margin: '0',
    WebkitLineClamp: '2',
    'line-clamp': '2',
    WebkitBoxOrient: 'vertical',
    wordBreak: 'break-all',
  },

  status: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#6E707A',
  },

  iconBtn: {
    width: '20px',
    height: '20px',
    padding: 0,
    '& svg': {
      width: '20px',
      height: '20px',
    },
  },

  textEditorStyles: {
    container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4px',
      height: '195px',
      backgroundColor: '#FFFFFF',
      borderRadius: '12px',
    },

    title: {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '15px',
      lineHeight: '148%',
      color: '#23252F',
    },

    subtitle: {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '150%',
      color: '#6E707A',
    },
  },

  customButtonStyle: {
    boxSizing: 'border-box',
    flexDirection: 'row',
    border: '1px solid #4d6ef5',
    outline: 'none',
    borderRadius: '8px',
    backgroundolor: 'transparent',
    fontWeight: 400,
    paddingInline: '15px',
    fontFamily: 'Inter',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gridGap: '10px',
    gap: '10px',
    cursor: 'pointer',
    color: '#4d6ef5',
    minWidth: '100px',
    padding: '7px',
  },
};
